import { useUpdateOwnPreference } from '@features/settings/hooks/useUpdateOwnPreference'
import { useStableCallback } from '@features/shared/hooks/useStableCallback'

/**
 * Pins area menus open beside the page, or unpins them back to opening on
 * hover: the Menus preference, saved for the signed-in user. A menu's pin
 * button and the table page's Tables button (which unpins a pinned Tables
 * menu) both go through here.
 */
export function useSetSidebarPinned() {
  const updateOwnPreference = useUpdateOwnPreference()
  return useStableCallback((pinned: boolean) =>
    updateOwnPreference('sidebar_menu_mode', 'sidebarMenuMode', pinned ? 'pinned' : 'hover')
  )
}
